<template>
  <div class="content-wrapper">
        <h4 class="card-title mb-4 ml-2 float-left"><span style="font-weight: 300">{{$route.name === 'AdminCategory' ? $t('Company') : $t('Category')}}: </span>{{category.name ? category.name : $route.params.id}}</h4>
        <h4 v-show="category.address" class="card-title mb-4 ml-2 float-right"><span style="font-weight: 300">{{$t('Address')}}: </span>{{category.address}}</h4>
        <p class="card-description">
          <!--For displaying tabular data. <code>&lt;b-table&gt;</code> supports pagination, filtering, sorting, custom rendering, events, and asynchronous data.-->
        </p><br><br>
        <b-tabs content-class="bg-white">
          <b-tab :title="$t('Groups')" id="groups">
            <b-container fluid class="no-padding">
              <!-- User Interface controls -->
            <!-- User Interface controls -->
            <b-row class="p-3">
              <b-col lg="4" class="my-1">
                <b-form-group
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      :placeholder="$t('Type to Search')"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">{{$t('Clear')}}</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col v-show="['System Admin'].includes($store.state.user.data.role)">
                <b-btn style="float:right;color:white" variant="light" v-b-modal.modal-group>{{$t('Add Group to Category')}}</b-btn>
              </b-col>

            </b-row>
              <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 70px;">
                <b-spinner
                  variant="secondary"
                ></b-spinner>
              </div>
            <!-- Main table element -->
            <b-table
              show-empty
              hover
              responsive
              :items="groups"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filterIncludedFields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered"
            >
              <template v-slot:cell(name)="row">
                <b-link v-if="$store.state.user.data.role === 'System Admin'" class="nav-link" :to="'/companies/'+$route.params.company+'/group/'+row.item.id">{{ row.item.name }} </b-link>
                <b-link v-else class="nav-link" :to="'/group/'+row.item.id">{{ row.item.name }} </b-link>
              </template>

              <template v-slot:cell(status)="row">
                <label :class="row.item.status === 'Active' ? 'text-success' : 'bg-danger btn-sm'" style="text-align: center;">{{$t(row.item.status) }}</label>
              </template>

              <template v-slot:cell(actions)="row" >
                <b-button variant="outline-primary" size="sm"  @click="editGroup(row.item)" class="mr-1">
                  {{$t('Edit')}}
                </b-button>
                <b-button v-show="['System Admin'].includes($store.state.user.data.role)" variant="outline-danger" size="sm" @click="deleteGroup(row.item)">
                  {{$t('Remove')}}
                </b-button>
              </template>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              class="my-5"
            ></b-pagination>
          </b-container>
          </b-tab>

        </b-tabs>
        <b-modal
          id="modal-group"
          ref="modal"
          title="Add new Group"
          @hidden="resetModal"
          @ok="submitGroup"
          okVariant="light"
          ok-title-html="<span style='color:white;'>Submit</span>"
          header-bg-variant="light"
          header-text-variant="white"
        >
          <form ref="form">
            <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 60px;">
              <b-spinner
                variant="secondary"
              ></b-spinner>
            </div>
            <b-form-group
              label="Name of Group"
              label-for="group-name"
            >
              <b-form-input
                id="group-name"
                v-model="form.name"
                :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                Name is a required field.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Alert Email 1"
              label-for="formemailone"
            >
              <b-form-input
                id="formemailone"
                autocomplete="email"
                type="text"
                :state="$v.form.alertEmail1.$dirty ? !$v.form.alertEmail1.$error : null"
                v-model="form.alertEmail1"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                {{$t('Email is invalid')}}.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Alert Email 2"
              label-for="formemailtwo"
            >
              <b-form-input
                id="formemailtwo"
                autocomplete="__away"
                type="text"
                v-model="form.alertEmail2"
                :state="$v.form.alertEmail2.$dirty ? !$v.form.alertEmail2.$error : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                {{$t('Email is invalid')}}.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Alert Email 3"
              label-for="formemail3"
            >
              <b-form-input
                id="formemail3"
                autocomplete="__away"
                type="text"
                v-model="form.alertEmail3"
                :state="$v.form.alertEmail3.$dirty ? !$v.form.alertEmail3.$error : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                {{$t('Email is invalid')}}.
              </b-form-invalid-feedback>
            </b-form-group>
          </form>
        </b-modal>
        <b-modal
          id="modal-edit-group"
          ref="modal"
          :title="$t('Edit Group')"
          @hidden="resetGroupModal"
          @ok="updateGroup"
          okVariant="light"
          ok-title-html="<span style='color:white;'>Save</span>"
          header-bg-variant="light"
          header-text-variant="white"
        >
          <form ref="form">
            <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
              <b-spinner
                variant="secondary"
              ></b-spinner>
            </div>
            <b-form-group
              label="Name"
              label-for="name-input"
            >
              <b-form-input
                id="name-input"
                type="text"
                autocomplete="__away"
                v-model="groupData.name"
                :state="$v.groupData.name.$dirty ? !$v.groupData.name.$error : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                {{$t('This is a required field')}}.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Alert Email 1"
              label-for="name-input"
            >
              <b-form-input
                id="email1"
                autocomplete="email"
                type="text"
                v-model="groupData.alertEmail1"
                :state="$v.groupData.alertEmail1.$dirty ? !$v.groupData.alertEmail1.$error : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                {{$t('Email is invalid')}}.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Alert Email 2"
              label-for="name-input"
            >
              <b-form-input
                id="email2"
                autocomplete="email2"
                type="text"
                v-model="groupData.alertEmail2"
                :state="$v.groupData.alertEmail2.$dirty ? !$v.groupData.alertEmail2.$error : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                {{$t('Email is invalid')}}.
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Alert Email 3"
              label-for="name-input"
            >
              <b-form-input
                id="email3"
                name="Email 3"
                autocomplete="email3"
                type="text"
                v-model="groupData.alertEmail3"
                :state="$v.groupData.alertEmail3.$dirty ? !$v.groupData.alertEmail3.$error : null"
              ></b-form-input>
              <b-form-invalid-feedback id="input-5-live-feedback">
                {{$t('Email is invalid')}}.
              </b-form-invalid-feedback>
            </b-form-group>
          </form>
        </b-modal>
    </div>

</template>

<script>
import moment from 'moment'
import { required, email } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      /* eslint-disable */
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      companyId: null,
      loading: false,
      category: {name: null},
      categoryName: '',
      categoryAddress: '',
      groupData: {
        name: null,
        alertEmail1: '',
        alertEmail2: '',
        alertEmail3: ''
      },
      groups: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [5, 10, 15],
      sortBy: 'name',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      form: {
        name: '',
        alertEmail1: '',
        alertEmail2: '',
        alertEmail3: '',
        category: this.$route.params.id,
        companyId: null,
        userCount: 0,
        users: []
      }
    }
  },
  validations: {
    form: {
      alertEmail1: {
        email,
        required
      },
      alertEmail2: {
        email,
        required
      },
      alertEmail3: {
        email,
        required
      },
      name: {
        required
      }
    },
    groupData: {
      alertEmail1: {
        email,
        required
      },
      alertEmail2: {
        email,
        required
      },
      alertEmail3: {
        email,
        required
      },
      name: {
        required
      }
    }
  },
  computed: {
    fields () {
      return [
        {
          key: 'name',
          label: this.$t('Name', this.$t.locale),
          sortable: true,
          sortDirection: 'asc',
          class: 'text-left'
        },
        {key: 'userCount', label: this.$t('Users in Group'), sortable: false, class: 'text-center'},
        {key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center'},
        {key: 'actions', label: this.$t('Actions'), class: 'text-center'}

      ]
    },
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted () {
    if (this.$route.params.activeTab) {
      this.$store.state.activeTab = this.$route.params.activeTab
    }
    if (this.$route.params.company) {
      this.companyId = this.$route.params.company
    } else {
      this.companyId = this.$store.state.user.data.companyId
    }
    let cat = this.$store.state.categories.find(i => i.name === this.$route.params.id)
    if (cat) {
      this.category = cat
    } else {
      this.fetchCategory()
    }
    this.fetchGroups()
  },
  methods: {
    isEmailValid: function (email) {
      return this.reg.test(email)
    },
    fetchCategory () {
      let self = this
      this.$firebase.firestore().collection('companies').doc(this.companyId).collection('categories').doc(this.$route.params.id).get()
        .then(function (querySnapshot) {
          var categoryData = querySnapshot.data()
          console.log(categoryData)
          self.category = categoryData
        })
    },
    fetchGroups (bypass = false) {
      let self = this
      if (self.groups.length === 0 || bypass) {
        let groups = this.$firebase.firestore().collectionGroup('groups').where('categoryId', '==', this.$route.params.id)
        if (this.$store.state.user.data.role === 'Supervisor'){
          groups = groups.where('users', 'array-contains', this.$store.state.user.data.uid)
        }

        groups.get().then(function (querySnapshot) {
          console.log('querySnapshot', querySnapshot.size)
          self.groups = []
          querySnapshot.forEach(async function (doc) {
            var groupData = doc.data()
            groupData.id = doc.id
            if (groupData.createdAt != null) {
              groupData.createdAt = moment(String(groupData.createdAt.toDate())).format('DD/MM/YYYY ')
            }
            self.groups.push(groupData)
          })
          // Set the initial number of items
          self.totalRows = self.groups.length
        })
      }
    },
    editGroup (item) {
      var group = this.groups.find(c => c.id === item.id)
      this.groupData.id = item.id
      this.groupData.name = group.name
      if (group.hasOwnProperty('alertEmails')) {
        this.groupData.alertEmail1 = group.alertEmails[0] !== undefined ? group.alertEmails[0] : ""
        this.groupData.alertEmail2 = group.alertEmails[1] !== undefined ? group.alertEmails[1] : ""
        this.groupData.alertEmail3 = group.alertEmails[2] !== undefined ? group.alertEmails[2] : ""
      }
      this.$bvModal.show('modal-edit-group')
    },
    updateGroup (e) {
      e.preventDefault()
      var self = this

      this.$v.groupData.name.$touch()

      if (this.$v.groupData.name.$anyError) {
        return
      }

      var emails = []

      if (this.groupData.alertEmail1 !== ''){
        this.$v.groupData.alertEmail1.$touch()
        if (this.$v.groupData.alertEmail1.$anyError) {
          return
        }

      }
      console.log('this.groupData.alertEmail2', this.groupData.alertEmail2)
      if (this.groupData.alertEmail2 !== ''){
        this.$v.groupData.alertEmail2.$touch()

        if (this.$v.groupData.alertEmail2.$anyError) {
          return
        }

      }
      console.log('this.groupData.alertEmail3', this.groupData.alertEmail3)

      if (this.groupData.alertEmail3 !== ''){
        this.$v.groupData.alertEmail3.$touch()

        if (this.$v.groupData.alertEmail3.$anyError) {
          return
        }
      }


      this.loading = true

      emails.push(this.groupData.alertEmail1)
      emails.push(this.groupData.alertEmail2)
      emails.push(this.groupData.alertEmail3)

      var payload =
        {
          id: this.groupData.id,
          name: this.groupData.name, companyId: this.companyId,
          alertEmails: emails
        }

      const updateGroup = this.$firebase.functions().httpsCallable('updateGroup')
      updateGroup(payload).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('Group Updated!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            self.fetchGroups(true)
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    resetGroupModal () {
      this.groupData.name = ''
      this.groupData.alertEmail1 = ''
      this.groupData.alertEmail2 = ''
      this.groupData.alertEmail3 = ''
      this.$v.$reset()
    },
    deleteGroup (group) {
      var self = this
      this.$bvModal.msgBoxConfirm(self.$t('You are about to delete this group. This action cannot be undone.'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'danger',
          okTitle: self.$t('Confirm'),
          centered: true
        })
        .then(value => {
          self.loading = true
          if (value) {
            var companyId = ''
            if (this.$route.params.company) {
              companyId = this.$route.params.company
            } else {
              companyId = this.$store.state.user.data.companyId
            }
            const deleteGroup = this.$firebase.functions().httpsCallable('deleteGroup')
            deleteGroup({id: group.id, companyId: companyId}).then(function (result) {
              // success or error handling
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 0,
                  showConfirmButton: true
                })
              } else {
                self.$swal({
                  title: self.$t('Group Deleted!'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                }).then(function (result) {
                  self.fetchGroups(true)
                  self.$refs.modal.hide()
                })
              }
              self.loading = false
            })
          }
        })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    resetModal () {
      this.form.name = ''
      this.form.alertEmail1 = ''
      this.form.alertEmail2 = ''
      this.form.alertEmail3 = ''
      this.$v.$reset()
    },
    submitGroup (e) {
      e.preventDefault()

      this.$v.form.name.$touch()

      if (this.$v.form.name.$anyError) {
        return
      }
      var emails = []

      if (this.form.alertEmail1 !== ''){
        this.$v.form.alertEmail1.$touch()

        if (this.$v.form.alertEmail1.$anyError) {
          return
        }

        emails.push(this.form.alertEmail1)

      }
      if (this.form.alertEmail2 !== ''){
        this.$v.form.alertEmail2.$touch()
        if (this.$v.form.alertEmail2.$anyError) {
          return
        }

        emails.push(this.form.alertEmail2)

      }

      if (this.form.alertEmail3 !== ''){
        this.$v.form.alertEmail3.$touch()

        if (this.$v.form.alertEmail3.$anyError) {
          return
        }

        emails.push(this.form.alertEmail3)
      }

      this.loading = true
      let self = this
      if (this.$route.params.company) {
        this.form.companyId = this.$route.params.company
      } else {
        this.form.companyId = this.$store.state.user.data.companyId
      }

      this.form.alertEmails = emails

      this.form.categoryName = this.category.name

      const createGroup = this.$firebase.functions().httpsCallable('createGroup')
      createGroup(this.form).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('Group Created!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            self.fetchGroups(true)
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    }
  }
}
</script>

<style>
  .card-body.with-border {
    border: 3px solid #00aeef;
    border-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Category.vue